import styled from "styled-components";

export const CvPage = styled.div`
  min-height: 100vh;
`;

export const CvLayout = styled.main`
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 72px;
  max-width: 960px;
  margin: 0 auto;
  padding: 72px 24px 104px;
  @media (max-width: 768px) {
    display: block;
    max-width: 320px;
    padding: 48px 0px 88px;
  }
`;

export const CvIntro = styled.aside`
  position: sticky;
  top: 104px;
  align-self: start;
  color: var(--subtle);
  font-family: "Literata", Georgia, serif;
  font-size: 16px;
  line-height: 26px;
  a {
    display: inline-block;
    margin-top: 12px;
    color: var(--heading);
    text-underline-offset: 3px;
  }
  @media (max-width: 768px) {
    position: static;
    margin-bottom: 56px;
  }
`;

export const CvLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin-top: 12px;

  a {
    margin-top: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`;

export const CvTitleLabel = styled.span`
  display: block;
  color: var(--muted);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const CvTitle = styled.h1`
  margin: 8px 0px 16px;
  color: var(--heading);
  font-size: 32px;
  line-height: 40px;
  font-weight: normal;
`;

export const CvBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 52px;
`;

export const CvSection = styled.section`
  color: var(--subtle);
  font-size: 15px;
  line-height: 24px;
  > p {
    margin: 18px 0px 0px;
  }
`;

export const CvEntry = styled.article`
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid var(--line);
  header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 24px;
  }
  h2 {
    margin: 0px;
    color: var(--text);
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
  }
  span {
    flex: none;
    color: var(--muted);
    font-size: 13px;
  }
  p {
    margin: 10px 0px 0px;
  }
  @media (max-width: 768px) {
    header {
      display: block;
    }
    span {
      display: block;
      margin-top: 5px;
    }
  }
`;
